import { jsonToQueryString } from './jsonToQueryString';
/**
 * Convert a JS object to query string and append to given url
 * @static
 * @param {string} url
 * @param {object} query
 * @return {string}
 */
export function appendQueryToUrl(
  url: string,
  query: Record<string, string | number | boolean | null | undefined>,
): string {
  const queryString = jsonToQueryString(query);
  if (!queryString.substring(1)) {
    return url;
  }
  // How do you even use `let` for `beforeHash` but `const` for `hash`
  // eslint-disable-next-line prefer-const
  let [beforeHash, hash] = url.split('#');
  if (beforeHash.indexOf('?') > -1) {
    beforeHash = `${beforeHash}&${queryString.substring(1)}`;
  } else {
    beforeHash = `${beforeHash}${queryString}`;
  }
  if (hash) {
    return `${beforeHash}#${hash}`;
  }
  return beforeHash;
}
